/*** IMPORTS FROM imports-loader ***/
var define = false;

// src/js/app.js

import Swiper from 'swiper/js/swiper.min';
require('@lib/iziModal/js/iziModal.js')($);

import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import SplitText from '../lib/gsap-pro/SplitText.js';

gsap.registerPlugin(ScrollToPlugin, SplitText);

// IMPORT de ScrollMagic (plus via window)
import ScrollMagic from 'scrollmagic';
import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';
import 'scrollmagic/scrollmagic/uncompressed/plugins/jquery.ScrollMagic';

import CookieManager   from '@components/cookie-manager';
import customGoogleMap from '@components/custom-google-map.js';
import MaterializeForm from '@components/materialize-form.js';
import Kira            from '@components/kira.js';
import Menu            from '@components/menu.js';
import Router          from '@utils/router.js';
import * as app        from '@components/global.js';
import main            from '@pages/main.js';
import news            from '@pages/news.js';
import animations      from '@pages/animations.js';
import sample          from '@pages/sample.js';
import contact         from '@pages/contact.js';

const routes = new Router([
  { file: animations, dependencies: [ app, Menu, Kira, ScrollMagic, gsap ] },
  { file: main,       dependencies: [ app, CookieManager, Swiper ] },
  { file: news,       dependencies: [ app ], resolve: '#page-news-archive' },
  { file: sample,     dependencies: [ app ], resolve: '#page-sample' },
  { file: contact,    dependencies: [ app, MaterializeForm, customGoogleMap ], resolve: '#page-contact' }
]);

(($) => { routes.load(); })(jQuery);

